// extracted by mini-css-extract-plugin
export default {"flex-column":"editPostModal_flex-column__h+GBo","edit-post":"editPostModal_edit-post__-S0Fr","flex-row":"editPostModal_flex-row__TQupk","page-size":"editPostModal_page-size__rq3WF"};